


















import Auth from "../shared/Auth";
import { TextBoxType } from "../shared/types/TextBoxType";
import { Component, Vue } from "vue-property-decorator";
import Clickbutton from "@/components/Clickbutton.vue";
import Textbox from "@/components/Textbox.vue";

@Component(
{
	components: {
		Clickbutton,
		Textbox
	}
})

export default class SignIn extends Vue
{
	data()
	{
		return {
			model: {
				email: "",
				password: ""
			},
			message: "",
			TextBoxType: TextBoxType
		};
	}

	signIn()
	{
		const that = this;

		new Auth().signIn
		(
			(this as any).model.email,
			(this as any).model.password,

			() =>
			{
				that.$router.push({ name: "list" });
			},

			() =>
			{
				(this as any).message = "Invalid credentials.";
			}
		);
	}
}
